export const PHONE_1 = "99794 08077";
export const PHONE_1_TEL = "+919979408077";
export const PHONE_2 = "81419 61037";
export const WA_NUMBER = "918141961037";
export const INSTAGRAM_URL = "https://www.instagram.com/momaycaterers77";
export const INSTAGRAM_HANDLE = "@momaycaterers77";
export const GOOGLE_REVIEWS_URL = "https://g.page/r/CbfccsqbGOkgEBM/review";

export const waLink = (msg) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;
export const WA_DEFAULT =
  "Hi Momay Caterers, I'm interested in catering for my event. I would like to know more about your menus and packages.";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const U = (id, w = 1400) => `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const NAV_LINKS = [
  { label: "About", id: "about" },
  { label: "Events", id: "events" },
  { label: "Menus", id: "menus" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "quote" },
];

export const HERO_IMG =
  "https://images.pexels.com/photos/8818732/pexels-photo-8818732.jpeg?auto=compress&cs=tinysrgb&w=1920";

export const ABOUT_IMG = U("photo-1616734755909-bb016ce64930", 1200);

export const WHY_CARDS = [
  { n: "01", title: "25+ Years of Experience", desc: "Decades of experience in creating memorable celebrations across Kutch." },
  { n: "02", title: "Pure Vegetarian", desc: "Carefully prepared vegetarian menus for every occasion." },
  { n: "03", title: "Jain Food", desc: "Thoughtfully curated Jain food options available on request." },
  { n: "04", title: "Fresh & Hygienic", desc: "Fresh preparation with strong attention to hygiene and quality." },
  { n: "05", title: "Customised Menus", desc: "Menus designed around your event, your guests and your preferences." },
  { n: "06", title: "Professional Service", desc: "Experienced catering and service staff for smooth execution." },
];

export const EVENTS = [
  { title: "Weddings", desc: "Elegant catering for unforgettable wedding celebrations.", img: U("photo-1587271407850-8d438ca9fdf2", 1000) },
  { title: "Engagements", desc: "Beautiful food and professional service for your special day.", img: U("photo-1727430256509-0f897d6f4765", 1000) },
  { title: "Birthdays & Parties", desc: "Fun, delicious and hassle-free catering.", img: U("photo-1530103862676-de8c9debad1d", 1000) },
  { title: "Corporate Events", desc: "Professional catering for meetings, conferences and corporate celebrations.", img: U("photo-1505373877841-8d25f7d46678", 1000) },
  { title: "Social Gatherings", desc: "Perfect menus for family and community gatherings.", img: U("photo-1529156069898-49953e39b3ac", 1000) },
  { title: "Private Events", desc: "Personalised catering for intimate celebrations.", img: U("photo-1777613112895-139720bd43c9", 1000) },
];

export const MENU_CATEGORIES = [
  { name: "Gujarati", blurb: "Shaak, dal, kadhi, farsan & thalis", img: U("photo-1742281257687-092746ad6021", 800) },
  { name: "Punjabi & North Indian", blurb: "Paneer specials, tandoor & breads", img: U("photo-1567188040759-fb8a883dc6d8", 800) },
  { name: "South Indian", blurb: "Dosas, idlis, uttapam & vada", img: U("photo-1630383249896-424e482df921", 800) },
  { name: "Chaat & Live Counters", blurb: "Pani puri, dabeli & live stations", img: U("photo-1601050690597-df0568f70950", 800) },
  { name: "Starters", blurb: "Kebabs, rolls & Indo-Chinese", img: U("photo-1541014741259-de529411b96a", 800) },
  { name: "Soups & Salads", blurb: "Hot soups & fresh salads", img: U("photo-1547592166-23ac45744acd", 800) },
  { name: "Pizza & Fast Food", blurb: "Pizzas, burgers, pasta & more", img: U("photo-1513104890138-7c749659a591", 800) },
  { name: "Main Course", blurb: "Signature curries, pulao & biryani", img: U("photo-1565557623262-b51c2513a641", 800) },
  { name: "Desserts & Mithai", blurb: "Jalebi, mithai, ice cream & gola", img: U("photo-1778448806221-d203c81c0b69", 800) },
  { name: "Beverages", blurb: "Lassi, juices, chaas & mocktails", img: U("photo-1437418747212-8d9709afab22", 800) },
  { name: "Jain Specials", blurb: "No onion-garlic, fully Jain menus", img: U("photo-1512621776951-a57141f2eefd", 800) },
];

const ALL_EVENTS = ["Wedding", "Party", "Corporate", "Social"];
const it = (name, cat, o = {}) => ({ name, desc: o.d || "", cat, jain: !!o.j, events: o.e || ALL_EVENTS, tier: o.t || "Classic" });

export const MENU_ITEMS = [
  it("Surati Undhiyu", "Gujarati", { d: "The winter classic, slow-cooked in traditional style", t: "Premium", e: ["Wedding", "Social"] }),
  it("Green Undhiyu", "Gujarati", { e: ["Wedding", "Social"], t: "Premium" }),
  it("Ringna no Olo", "Gujarati", { d: "Smoky roasted brinjal, village style" }),
  it("Sev Tameta nu Shaak", "Gujarati"),
  it("Lasaniya Batata", "Gujarati", { d: "Garlic-tossed baby potatoes" }),
  it("Bhindi Masala", "Gujarati", { j: true }),
  it("Panch Kathol", "Gujarati", { d: "Five-bean festive shaak", j: true }),
  it("Navratan Kathol Muthiya", "Gujarati"),
  it("Aalu Bharela", "Gujarati", { d: "Stuffed spiced potatoes" }),
  it("Gujarati Dal", "Gujarati", { j: true, d: "Sweet-tangy, tempered the traditional way" }),
  it("Gujarati Kadhi", "Gujarati", { j: true }),
  it("Bhattiya Kadhi", "Gujarati"),
  it("Masala Khichdi", "Gujarati", { j: true }),
  it("Dal Masala Khichdi", "Gujarati"),
  it("Khaman Dhokla", "Gujarati", { j: true }),
  it("Sandwich Dhokla", "Gujarati", { j: true }),
  it("Khandvi", "Gujarati", { j: true, d: "Silky gram-flour rolls with mustard & coconut" }),
  it("Patra", "Gujarati"),
  it("Handvo", "Gujarati", { d: "Baked lentil-vegetable cake" }),
  it("Methi na Gota", "Gujarati"),
  it("Batata Vada", "Gujarati"),
  it("Jalebi Ganthiya", "Gujarati", { d: "The classic Kutch breakfast pairing", e: ["Social", "Party"] }),
  it("Batata Poha", "Gujarati", { e: ["Corporate", "Social"] }),
  it("Upma", "Gujarati", { e: ["Corporate", "Social"] }),
  it("Aloo Paratha", "Gujarati"),
  it("Paneer Pyaz Paratha", "Gujarati", { t: "Premium" }),
  it("Cheese Garlic Paratha", "Gujarati", { t: "Premium" }),

  it("Paneer Tikka Masala", "Punjabi & North Indian", { d: "Tandoor-smoked paneer in rich masala", t: "Premium" }),
  it("Shahi Paneer", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Angara", "Punjabi & North Indian", { d: "Fiery, smoky and bold", t: "Premium" }),
  it("Paneer Lababdar", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Makhani", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Pasanda", "Punjabi & North Indian", { t: "Royal" }),
  it("Paneer Kadai", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Handi", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Do Pyaza", "Punjabi & North Indian"),
  it("Paneer Bhurji", "Punjabi & North Indian"),
  it("Palak Paneer", "Punjabi & North Indian"),
  it("Matar Paneer", "Punjabi & North Indian"),
  it("Cheese Paneer Anguri", "Punjabi & North Indian", { t: "Royal" }),
  it("Kaju Paneer Masala", "Punjabi & North Indian", { t: "Royal" }),
  it("Kaju Curry", "Punjabi & North Indian", { t: "Royal" }),
  it("Khoya Kaju", "Punjabi & North Indian", { t: "Royal" }),
  it("Veg Kolhapuri", "Punjabi & North Indian", { d: "Fiery Maharashtrian classic" }),
  it("Veg Jaipuri", "Punjabi & North Indian"),
  it("Veg Maharaja", "Punjabi & North Indian", { t: "Premium" }),
  it("Methi Matar Malai", "Punjabi & North Indian", { t: "Premium" }),
  it("Malai Kofta", "Punjabi & North Indian", { t: "Royal" }),
  it("Nargisi Kofta", "Punjabi & North Indian", { t: "Royal" }),
  it("Dal Makhani", "Punjabi & North Indian", { d: "Overnight-simmered, finished with cream", t: "Premium" }),
  it("Dal Tadka", "Punjabi & North Indian"),
  it("Shahi Dal", "Punjabi & North Indian", { t: "Premium" }),
  it("Garlic Naan", "Punjabi & North Indian"),
  it("Cheese Naan", "Punjabi & North Indian", { t: "Premium" }),
  it("Paneer Garlic Naan", "Punjabi & North Indian", { t: "Premium" }),
  it("Amritsari Kulcha", "Punjabi & North Indian"),
  it("Lachha Paratha", "Punjabi & North Indian"),
  it("Rumali Roti", "Punjabi & North Indian"),
  it("Missi Roti", "Punjabi & North Indian"),

  it("Idli Sambar", "South Indian", { j: true, e: ["Corporate", "Social"] }),
  it("Rava Idli", "South Indian", { e: ["Corporate", "Social"] }),
  it("Masala Idli", "South Indian"),
  it("Medu Vada", "South Indian", { j: true, d: "Crisp outside, cloud-soft inside" }),
  it("Dal Vada", "South Indian"),
  it("Masala Dosa", "South Indian", { d: "Golden, crisp, made to order" }),
  it("Mysore Masala Dosa", "South Indian", { t: "Premium" }),
  it("Szechwan Dosa", "South Indian"),
  it("Paper Dosa", "South Indian"),
  it("Paneer Dosa", "South Indian", { t: "Premium" }),
  it("Pav Bhaji Dosa", "South Indian"),
  it("Palak Dosa", "South Indian"),
  it("Rava Dosa", "South Indian"),
  it("Chinese Dosa", "South Indian"),
  it("Uttapam", "South Indian"),
  it("Masala Uttapam", "South Indian"),
  it("Mini Uttapam", "South Indian", { e: ["Party", "Corporate"] }),
  it("Pineapple Uttapam", "South Indian", { t: "Premium" }),

  it("Pani Puri", "Chaat & Live Counters", { d: "Crisp puris with flavoured waters, served live", t: "Premium" }),
  it("Sev Puri", "Chaat & Live Counters"),
  it("Dahi Puri", "Chaat & Live Counters"),
  it("Masala Puri", "Chaat & Live Counters"),
  it("Ragda Puri", "Chaat & Live Counters"),
  it("Dahi Vada", "Chaat & Live Counters"),
  it("Rangila Dahi Vada", "Chaat & Live Counters", { t: "Premium" }),
  it("Raj Kachori", "Chaat & Live Counters", { t: "Premium" }),
  it("Khasta Kachori", "Chaat & Live Counters"),
  it("Basket Chaat", "Chaat & Live Counters", { d: "Edible basket loaded with chaat", t: "Premium" }),
  it("Aloo Tikki Chaat", "Chaat & Live Counters"),
  it("Chole Tikki Chaat", "Chaat & Live Counters"),
  it("Papdi Chaat", "Chaat & Live Counters"),
  it("Bombay Bhel", "Chaat & Live Counters"),
  it("Dabeli", "Chaat & Live Counters", { d: "Kutch's own famous street bite" }),
  it("Vada Pav", "Chaat & Live Counters"),
  it("Misal Pav", "Chaat & Live Counters"),
  it("Dhokla Chaat", "Chaat & Live Counters"),

  it("Paneer Chilli Dry", "Starters", { t: "Premium" }),
  it("Hara Bhara Kebab", "Starters"),
  it("Seekh Kebab", "Starters", { t: "Premium" }),
  it("Veg Lollipop", "Starters"),
  it("Cheese Corn Balls", "Starters"),
  it("Spring Roll", "Starters"),
  it("Dragon Potato", "Starters"),
  it("Veg Manchurian Dry", "Starters"),
  it("Veg Crispy", "Starters"),
  it("Chinese Bhel", "Starters"),
  it("Chinese 65", "Starters", { t: "Premium" }),
  it("Potato Chilli", "Starters"),
  it("American Roll", "Starters"),
  it("Veg Cutlet", "Starters"),
  it("Badam Tikki", "Starters", { t: "Premium" }),
  it("Finger Chips", "Starters"),
  it("Gold Coin", "Starters"),
  it("Chinese Platter", "Starters", { t: "Royal", e: ["Wedding", "Corporate"] }),

  it("Tomato Cream Soup", "Soups & Salads", { j: true }),
  it("Manchow Soup", "Soups & Salads"),
  it("Hot & Sour Soup", "Soups & Salads"),
  it("Sweet Corn Soup", "Soups & Salads", { j: true }),
  it("Lemon Coriander Soup", "Soups & Salads", { j: true }),
  it("Palak Soup", "Soups & Salads"),
  it("Veg Clear Soup", "Soups & Salads", { j: true }),
  it("Mexican Soup", "Soups & Salads"),
  it("Broccoli Almond Soup", "Soups & Salads", { t: "Premium" }),
  it("Green Salad", "Soups & Salads", { j: true }),
  it("Russian Salad", "Soups & Salads"),
  it("Fruit Cream Salad", "Soups & Salads", { j: true }),
  it("Corn Salad", "Soups & Salads", { j: true }),
  it("Kachumber Salad", "Soups & Salads", { j: true }),
  it("Mexican Salad", "Soups & Salads"),

  it("Veg Pizza", "Pizza & Fast Food"),
  it("Italian Pizza", "Pizza & Fast Food", { t: "Premium" }),
  it("Paneer Tikka Pizza", "Pizza & Fast Food", { t: "Premium" }),
  it("Tandoori Paneer Pizza", "Pizza & Fast Food", { t: "Premium" }),
  it("Mexican Pizza", "Pizza & Fast Food"),
  it("Thin Crust Pizza", "Pizza & Fast Food"),
  it("Chocolate Pizza", "Pizza & Fast Food", { e: ["Party"] }),
  it("Garlic Bread", "Pizza & Fast Food"),
  it("Bruschetta", "Pizza & Fast Food"),
  it("Veg Burger", "Pizza & Fast Food"),
  it("Paneer Burger", "Pizza & Fast Food"),
  it("Mexican Burger", "Pizza & Fast Food"),
  it("Red Chilli Pasta", "Pizza & Fast Food"),
  it("White Sauce Pasta", "Pizza & Fast Food"),
  it("Chocolate Sandwich", "Pizza & Fast Food", { e: ["Party"] }),
  it("Mexican Garlic Sandwich", "Pizza & Fast Food"),
  it("Veg Hot Dog", "Pizza & Fast Food"),

  it("Veg Handi", "Main Course", { t: "Premium" }),
  it("Veg Kadai", "Main Course"),
  it("Veg Jwalamukhi", "Main Course", { t: "Premium" }),
  it("Veg Jalfrezi", "Main Course"),
  it("Paneer Korma", "Main Course", { t: "Royal" }),
  it("Navratan Korma", "Main Course", { t: "Royal" }),
  it("Veg Badshah", "Main Course", { t: "Royal" }),
  it("Veg Dum Biryani", "Main Course", { d: "Layered, sealed and slow-steamed", t: "Royal" }),
  it("Hyderabadi Biryani", "Main Course", { t: "Royal" }),
  it("Kashmiri Pulao", "Main Course", { t: "Premium" }),
  it("Dry Fruit Pulao", "Main Course", { t: "Premium" }),
  it("Jeera Rice", "Main Course"),
  it("Tawa Pulao", "Main Course"),
  it("Masala Pulao", "Main Course"),

  it("Jalebi Rabri", "Desserts & Mithai", { j: true, d: "Hot jalebis over chilled rabri", t: "Premium" }),
  it("Kesar Jalebi", "Desserts & Mithai", { j: true }),
  it("Apple Jalebi", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Basundi", "Desserts & Mithai", { j: true }),
  it("Kesar Shrikhand", "Desserts & Mithai", { j: true }),
  it("Mango Shrikhand", "Desserts & Mithai", { j: true }),
  it("Dry Fruit Shrikhand", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Sitafal Rabri", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Rasgulla", "Desserts & Mithai", { j: true }),
  it("Rajbhog", "Desserts & Mithai", { j: true }),
  it("Kaju Katri", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Kaju Roll", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Mohanthal", "Desserts & Mithai", { j: true, d: "The Kutchi festive favourite" }),
  it("Motichur Ladoo", "Desserts & Mithai", { j: true }),
  it("Churma Ladoo", "Desserts & Mithai", { j: true }),
  it("Gulab Jamun", "Desserts & Mithai", { j: true }),
  it("Kala Jamun", "Desserts & Mithai", { j: true }),
  it("Malpua", "Desserts & Mithai", { j: true }),
  it("Gajar Halwa", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Dry Fruit Halwa", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Puran Poli", "Desserts & Mithai", { j: true }),
  it("Malai Sandwich", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Anjeer Barfi", "Desserts & Mithai", { j: true, t: "Premium" }),
  it("Rajbhog Ice Cream", "Desserts & Mithai"),
  it("Butterscotch Ice Cream", "Desserts & Mithai"),
  it("American Dry Fruit Ice Cream", "Desserts & Mithai", { t: "Premium" }),
  it("Dry Fruit Gola", "Desserts & Mithai", { e: ["Party", "Wedding"] }),
  it("Ice Cream Gola", "Desserts & Mithai", { e: ["Party", "Wedding"] }),

  it("Sweet Lassi", "Beverages", { j: true }),
  it("Khari Lassi", "Beverages", { j: true }),
  it("Dry Fruit Lassi", "Beverages", { j: true, t: "Premium" }),
  it("Strawberry Lassi", "Beverages", { j: true }),
  it("Masala Chaas", "Beverages", { j: true, d: "Spiced buttermilk, endlessly refilled" }),
  it("Mosambi Juice", "Beverages", { j: true }),
  it("Pineapple Juice", "Beverages", { j: true }),
  it("Orange Juice", "Beverages", { j: true }),
  it("Mango Juice", "Beverages", { j: true }),
  it("Anar Juice", "Beverages", { j: true, t: "Premium" }),
  it("Ganga Jamna Juice", "Beverages", { j: true }),
  it("Jaljeera", "Beverages", { j: true }),
  it("Mocktail Counter", "Beverages", { d: "Live-crafted welcome drinks", t: "Royal", e: ["Wedding", "Corporate"] }),

  it("Jain Gujarati Thali", "Jain Specials", { j: true, t: "Royal", d: "Complete thali, no onion-garlic-root" }),
  it("Jain Paneer Tikka", "Jain Specials", { j: true, t: "Premium" }),
  it("Jain Pav Bhaji", "Jain Specials", { j: true }),
  it("Jain Veg Biryani", "Jain Specials", { j: true, t: "Premium" }),
  it("Jain Pizza Counter", "Jain Specials", { j: true, t: "Premium" }),
  it("Jain Mithai Selection", "Jain Specials", { j: true }),
];

export const SIGNATURES = [
  { name: "Paneer Tikka Angara", desc: "Charcoal-kissed paneer with smoked spices — the starter guests queue for.", img: U("photo-1567188040759-fb8a883dc6d8", 900) },
  { name: "Traditional Undhiyu", desc: "A slow-cooked Gujarati winter classic, served with hot puris.", img: U("photo-1585937421612-70a008356fbe", 900) },
  { name: "Live Pani Puri", desc: "Crisp puris, five flavoured waters, endless refills.", img: U("photo-1781243680771-1fea4521e196", 900) },
  { name: "Masala Dosa, Live", desc: "Golden and crisp, spread and folded in front of your guests.", img: U("photo-1743517894265-c86ab035adef", 900) },
  { name: "Dal Tadka & Naan", desc: "Ghee-tempered yellow dal with red chillies, served with tandoor-fresh naan.", img: U("photo-1755090154817-58d9d36ec988", 900) },
  { name: "Jalebi with Kesar Rabri", desc: "Hot jalebis over chilled saffron rabri — the perfect ending.", img: U("photo-1778448806371-b55a71bf9a35", 900) },
];

export const LIVE_COUNTERS = [
  { name: "Chaat Counter", desc: "Bhel, sev puri and dahi puri built fresh to order." },
  { name: "Dosa Counter", desc: "Crisp dosas and uttapams off a live griddle." },
  { name: "Pizza Counter", desc: "Wood-fired style veg & Jain pizzas, made live." },
  { name: "Pani Puri", desc: "Five flavoured waters and unlimited puris." },
  { name: "South Indian Counter", desc: "Idli, vada and filter coffee on demand." },
  { name: "Dessert Counter", desc: "Hot jalebi, rabri and ice cream, served live." },
  { name: "Custom Live Stations", desc: "Tell us your idea — we build the station around it." },
];

export const LIVE_IMG = U("photo-1586357507341-3fbe59f2a5d9", 1200);
export const PIZZA_IMG = U("photo-1513104890138-7c749659a591", 800);

export const GALLERY = [
  { img: HERO_IMG, cat: "Buffet", alt: "Premium vegetarian wedding buffet by Momay Caterers Kutch" },
  { img: U("photo-1585937421612-70a008356fbe", 900), cat: "Food", alt: "Indian vegetarian curries and thali catering" },
  { img: U("photo-1587271636175-90d58cdad458", 900), cat: "Weddings", alt: "Indian wedding mandap ceremony in Kutch" },
  { img: U("photo-1665960213508-48f07086d49c", 900), cat: "Weddings", alt: "Couple in traditional Indian wedding attire" },
  { img: U("photo-1742281257707-0c7f7e5ca9c6", 900), cat: "Buffet", alt: "Indian thali wedding buffet spread" },
  { img: U("photo-1542042161784-26ab9e041e89", 900), cat: "Events", alt: "Indian engagement ceremony, mehndi and ring" },
  { img: U("photo-1743615467363-250466982515", 900), cat: "Live Counters", alt: "Live dosa counter with chutneys and sambar" },
  { img: U("photo-1513104890138-7c749659a591", 900), cat: "Live Counters", alt: "Live pizza counter catering" },
  { img: U("photo-1414235077428-338989a2e8c0", 900), cat: "Service", alt: "Fine dining service and plating" },
  { img: U("photo-1778448806228-36ce0660a8ef", 900), cat: "Food", alt: "Indian mithai and sweets catering" },
  { img: U("photo-1565556250026-9ba22083e3e0", 900), cat: "Events", alt: "Traditional Indian feast at a private celebration" },
  { img: U("photo-1742281258189-3b933879867a", 900), cat: "Food", alt: "Professional Indian vegetarian thali presentation" },
  { img: U("photo-1778448806852-db6a837fa98f", 900), cat: "Food", alt: "Jalebi and festive Indian sweets platter" },
  { img: U("photo-1577219492769-b63a779fac28", 900), cat: "Service", alt: "Professional chef preparing food live" },
];

export const STEPS = [
  { n: "01", title: "Tell Us About Your Event", desc: "Date, location, number of guests and event type." },
  { n: "02", title: "Choose Your Menu", desc: "Our team helps you create the perfect menu." },
  { n: "03", title: "Finalise The Details", desc: "Service, counters, presentation and requirements." },
  { n: "04", title: "Enjoy Your Celebration", desc: "We handle the food and service while you enjoy your event." },
];

export const AREAS = {
  primary: "Mandvi, Kutch, Gujarat",
  others: ["Bhuj", "Gandhidham", "Mundra", "Kutch", "Ahmedabad", "Other Locations"],
};

export const INSTA_IMAGES = [
  U("photo-1585937421612-70a008356fbe", 700),
  U("photo-1601050690597-df0568f70950", 700),
  U("photo-1567188040759-fb8a883dc6d8", 700),
  U("photo-1630383249896-424e482df921", 700),
  U("photo-1778448806852-db6a837fa98f", 700),
  U("photo-1519225421980-715cb0215aed", 700),
];
